import { useQuery } from 'react-query';
import { bucketsKeys } from '../../cache-keys/bucketsKeys';
import { useAPI } from '@axo/shared/data-access/provider';
import { ace_api } from '@axo/shared/data-access/api';

export function useBucketSummary(id: string) {
  const api = useAPI();

  return useQuery({
    queryKey: [bucketsKeys.bucketSummaries()],
    queryFn: ace_api.getBucketSummaries(api),
    enabled: id !== '' && api.token !== '',
    select: (data) => data?.Items?.find((bucket) => bucket.BucketID === id),
  });
}
